// extracted by mini-css-extract-plugin
export default {"mintOptionSelection":"MintOptionSelection_mintOptionSelection__kIGER","galaxy":"MintOptionSelection_galaxy__B7BO8"};